import React from 'react'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'

import { withPortalIdByRoute } from '../portal/withPortalIdByRoute'
import { connectPortal } from '../portal/withProtectedPortalRoute'

//need connectPortal, withRouter, withPortalIdByRoute
export const withPasscodeUrlHandler = WrappedComponent => {
  return class PasscodeUrlHandler extends React.Component {
    componentDidMount() {
      let params = queryString.parse(this.props.location.search)
      if (params.passcode) {
        this.props.setInfo('passcode', params.passcode)
        this.props.redirectToMenuPage()
      }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}

export default compose(
  connectPortal,
  withRouter,
  withPortalIdByRoute,
  withPasscodeUrlHandler,
)



// WEBPACK FOOTER //
// ./src/modules/passcode/withPasscodeUrlHandler.js